export const toCamelCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/(?:^|[^a-zA-Z0-9]+)([a-zA-Z0-9])/g, (_, char, index) =>
      index === 0 ? char.toLowerCase() : char.toUpperCase(),
    );
};

export const toSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .toLowerCase();
};

export const encodeData = <T extends Record<string, unknown>>(data: T): string => {
  const jsonString = JSON.stringify(data);

  return btoa(jsonString);
};
